import React from "react";
import Sidebar from "../../components/layout/Sidebar";
import Header from "../../components/layout/Header";
import ChatDetail from "./ChatDetail";
import { useState } from "react";
import "./ChatDetailWrapper.scss";

const ChatDetailWrapper: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="chat-detail-wrapper">
      <Sidebar className={isSidebarOpen ? "open" : ""} />
      {isSidebarOpen && (
        <div className="overlay" onClick={() => setIsSidebarOpen(false)} />
      )}

      <div className="chat-detail-main">
        <Header
          onMenuClick={() => setIsSidebarOpen((p) => !p)}
        />
        <ChatDetail />
      </div>
    </div>
  );
};

export default ChatDetailWrapper;
